$(function() {

    $('.video__play').on('click', function(e) {
        var $video = $('.video__embed');

        //Hide other elements
        $('.video__play').fadeOut(150);
        $('.video__left').fadeOut(150);
        $('.video__right').fadeOut(150);

        //Change video SRC so it autoplays
        $("#video")[0].src += "&autoplay=1";
        console.log($("#video")[0].src);

        //Show video
        $video.delay(200).fadeIn(300, function() {

            //Scroll to top of video element
            scroll_to_pos(get_element_pos($('.video__embed')), 800);

        });

        e.preventDefault();

    });

});